import React from 'react';

import FeatureIcon from './feature-icon';

const baseFeatures = [
  '多渠道接入',
  '当前对话接待',
  '访客列表',
  '工单',
  '顾客名片',
  '排队列表',
  '访客来源',
  '团队管理',
  '对话置顶',
  '留言',
  '对话标签',
  '顾客标签'
];

const FeatureBase = () => {
  return (
    <>
      <div className="detail-base-icons">
        {baseFeatures.map((name, i) => {
          return (
            <div key={i} className="base-icon">
              <FeatureIcon type={`p2i${`${i + 1}`.padStart(2, '0')}`} name={name} />
            </div>
          );
        })}
      </div>
    </>
  );
};

export default FeatureBase;
